import {Component, computed, effect, inject, ModelSignal, signal, viewChildren} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {TextItem} from './text-item/text-item'
import {MatButton} from '@angular/material/button'
import {Profit} from '../../services/profit'
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog'
import {MatChipListbox, MatChipOption} from '@angular/material/chips'

@Component({
  selector: 'spb-write-help',
  imports: [
    FormsModule,
    TextItem,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatChipListbox,
    MatChipOption
  ],
  templateUrl: './write-help.html',
  styleUrl: './write-help.scss'
})
export class WriteHelp {

  public texts = viewChildren(TextItem)

  public textSignals = signal<ModelSignal<string | undefined>[]>([])

  public textsCombined = computed(() => {
    return this.textSignals().map(x => x()?.trim()).join('\n\n')
  })

  constructor() {
    effect(() => {
      this.textSignals.set(this.texts().map(t => t.text()!.text))
    })
  }

  public customerType = signal<number | null>(null)

  public reason = signal<number[] | null>(null)

  public comp = signal<number[] | null>(null)

  public profit = inject(Profit)

  public statement = signal<number | null>(null)

}
